import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, Play, FileText, Zap, Target } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: BookOpen,
    title: 'Ebook Completo',
    description: 'El sistema completo en formato digital. Más de 120 páginas de estrategias probadas, escritas de forma directa y sin relleno.',
    color: 'crimson'
  }, {
    icon: Headphones,
    title: 'Audiobook Premium',
    description: 'Escuchalo donde quieras. Ideal para absorber el contenido mientras hacés tu rutina diaria o vas al gimnasio.',
    color: 'crimson'
  }, {
    icon: Play,
    title: 'Videos Explicativos',
    description: 'Videos cortos y prácticos que profundizan cada fase del sistema con ejemplos reales y situaciones concretas.',
    color: 'crimson'
  }, {
    icon: Target,
    title: 'Guía de Aplicación Rápida',
    description: 'Un resumen ejecutivo para que puedas aplicar las técnicas más poderosas en tu próxima interacción — hoy mismo.',
    color: 'crimson'
  }, {
    icon: FileText,
    title: 'Hojas de Trabajo',
    description: 'Ejercicios prácticos para internalizar cada concepto y construir tu confianza de forma progresiva.',
    color: 'crimson'
  }, {
    icon: Zap,
    title: 'Actualizaciones de por Vida',
    description: 'Cada vez que actualicemos el manual con nuevo contenido, lo recibís automáticamente. Sin costo adicional.',
    color: 'crimson'
  }];
  return <section className="py-20 sm:py-28 bg-secondary" data-id="element-192">
      <div className="max-w-6xl mx-auto px-5 sm:px-6" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-194">
          <p className="text-crimson font-bold text-sm uppercase tracking-[0.2em] mb-4" data-id="element-195">
            Todo lo que incluye
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-196">
            ¿Qué recibís hoy?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-197">
            No es solo un ebook. Es un sistema completo diseñado para
            transformar tu forma de conectar con las mujeres.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-198">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 25
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="group p-6 bg-primary rounded-xl border border-white/5 hover:border-crimson/20 transition-colors duration-300" data-id="element-199">
              <div className="w-12 h-12 bg-crimson/10 rounded-lg flex items-center justify-center mb-5 group-hover:bg-crimson/15 transition-colors" data-id="element-200">
                <item.icon size={22} className="text-crimson" data-id="element-201" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-202">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-203">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}